import { render, staticRenderFns } from "./PageNewZoneTicket.vue?vue&type=template&id=204c3320&scoped=true&"
import script from "./PageNewZoneTicket.vue?vue&type=script&lang=js&"
export * from "./PageNewZoneTicket.vue?vue&type=script&lang=js&"
import style0 from "./PageNewZoneTicket.vue?vue&type=style&index=0&id=204c3320&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204c3320",
  null
  
)

export default component.exports